/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar as ChartBar, Pie } from "react-chartjs-2";
import SideNav from "../SideNav/SideNav";
import { fetchUrl } from "../../config";
import "./Dashboard.css";

// Chart.js-এর জন্য উপাদান রেজিস্ট্রেশন
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
);

function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [userName, setUserName] = useState([]);
  const accessToken = localStorage.getItem("access_token");

  useEffect(() => {
    // ইউজার ডাটা ফেচ
    fetch(`${fetchUrl}/api/employee/own/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((res) => res.json())
      .then((data) => setUserName(data));

    // ড্যাশবোর্ড স্ট্যাটাস ফেচ
    fetch(`${fetchUrl}/api/dashboard/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((res) => res.json())
      .then((data) => setDashboardData(data));
  }, [accessToken]);

  if (!dashboardData) {
    return <StatusGridSkeleton />;
  }

  const isSuperUser = userName?.[0]?.is_superuser;

  // ==========================================
  // 📊 3-Month Sales & Orders Multi-Axis Bar Chart
  // ==========================================
  const barChartData = {
    labels: [
      dashboardData.prev_month_name || "Prev Month",
      dashboardData.last_month_name || "Last Month",
      dashboardData.this_month_name || "This Month",
    ],
    datasets: [
      {
        label: "Total Orders (Count)",
        data: [
          dashboardData.prev_month_orders || 0,
          dashboardData.last_month_orders || 0,
          dashboardData.this_month_orders || 0,
        ],
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
        yAxisID: "y",
      },
      ...(isSuperUser
        ? [
            {
              label: "Total Revenue (TK)",
              data: [
                dashboardData.prev_month_sell || 0,
                dashboardData.last_month_sell || 0,
                dashboardData.this_month_sell || 0,
              ],
              backgroundColor: "rgba(75, 192, 192, 0.6)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
              yAxisID: "y1",
            },
          ]
        : []),
    ],
  };

  const barChartOptions = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: { display: true, text: "Orders Count" },
        grid: { drawOnChartArea: true },
      },
      ...(isSuperUser
        ? {
            y1: {
              type: "linear",
              display: true,
              position: "right",
              title: { display: true, text: "Revenue (TK)" },
              grid: { drawOnChartArea: false },
            },
          }
        : {}),
    },
  };

  const isMobile =
    typeof window !== "undefined" ? window.innerWidth < 768 : false;
  const chartWidth = isMobile ? "65%" : "85%";
  return (
    <div
      style={{ background: "#f8fafc", minHeight: "100vh", color: "#334155" }}
    >
      <div className="NavRow">
        <SideNav />
        <div className="bodyLayout">
          <div className="dahshboardMain" style={{ padding: "20px" }}>
            {/* হেডার সেকশন */}
            <h2 className="text-center" style={{ color: "#1e293b" }}>
              Welcome {userName?.[0]?.username}
            </h2>
            <h3 className="text-center mb-5" style={{ color: "#64748b" }}>
              to Admin Panel
            </h3>
            {/* মেইন ড্যাশবোর্ড গ্রিড প্যারেন্ট (ফ্লেক্স কলাম ডিরেকশন মোবাইলের জন্য) */}
            <div className="d-flex flex-column">
              {/* ============================================================== */}
              {/* 📊 চার্ট সেকশন (ডেস্কটপে উপরে থাকবে: order-lg-1, মোবাইলে নিচে: order-2) */}
              {/* ============================================================== */}
              <div className="row g-4 mb-5 px-2 px-sm-0 order-2 order-lg-1 ">
                {/* ১. Today's Ratio Pie Chart */}
                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="ratioCard h-100"
                    style={{
                      background: "#fff",
                      padding: "20px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <h5 style={{ color: "#1e293b", margin: "0 0 2px 0" }}>
                        Today&apos;s Ratio
                      </h5>
                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "13px",
                          margin: "0 0 10px 0",
                        }}
                      >
                        Total Orders: <b>{dashboardData.today_all || 0}</b>
                      </p>
                    </div>
                    <div
                      style={{
                        maxWidth: "95%" /* পিসিতে পুরোটা ছড়াতে পারবে */,
                        width: chartWidth /* কার্ডের বর্ডার থেকে একটু গ্যাপ রাখবে */,
                        margin: "0 auto",
                      }}
                    >
                      <Pie
                        data={{
                          // এখানে লেবেলের সাথে সংখ্যা ডাইনামিক্যালি যোগ করা হয়েছে
                          labels: [
                            `Confirmed (${dashboardData.today_confirm || 0})`,
                            `Cancelled (${dashboardData.today_cancel || 0})`,
                            `Pending (${dashboardData.today_pending || 0})`,
                          ],
                          datasets: [
                            {
                              data: [
                                dashboardData.today_confirm_ratio || 0,
                                dashboardData.today_cancel_ratio || 0,
                                dashboardData.today_pending_ratio || 0,
                              ],
                              backgroundColor: [
                                "#22c55e",
                                "#ef4444",
                                "#eab308",
                              ],
                              borderWidth: 1,
                              borderColor: "#fff",
                            },
                          ],
                        }}
                        options={{
                          responsive: true,
                          plugins: {
                            legend: {
                              position: "bottom",
                              labels: {
                                color: "#334155",
                                font: { size: 10 },
                                boxWidth: 10,
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* ২. Yesterday's Ratio Pie Chart */}
                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="ratioCard h-100"
                    style={{
                      background: "#fff",
                      padding: "20px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <h5 style={{ color: "#1e293b", margin: "0 0 2px 0" }}>
                        Yesterday&apos;s Ratio
                      </h5>
                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "13px",
                          margin: "0 0 10px 0",
                        }}
                      >
                        Total Orders: <b>{dashboardData.yesterday_all || 0}</b>
                      </p>
                    </div>
                    <div
                      style={{
                        maxWidth: "95%" /* পিসিতে পুরোটা ছড়াতে পারবে */,
                        width: chartWidth,
                        margin: "0 auto",
                      }}
                    >
                      <Pie
                        data={{
                          // গতকালকের লেবেলের সাথে সংখ্যা যোগ
                          labels: [
                            `Confirmed (${
                              dashboardData.yesterday_confirm || 0
                            })`,
                            `Cancelled (${
                              dashboardData.yesterday_cancel || 0
                            })`,
                            `Pending (${dashboardData.yesterday_pending || 0})`,
                          ],
                          datasets: [
                            {
                              data: [
                                dashboardData.yesterday_confirm_ratio || 0,
                                dashboardData.yesterday_cancel_ratio || 0,
                                dashboardData.yesterday_pending_ratio || 0,
                              ],
                              backgroundColor: [
                                "#16a34a",
                                "#dc2626",
                                "#ca8a04",
                              ],
                              borderWidth: 1,
                              borderColor: "#fff",
                            },
                          ],
                        }}
                        options={{
                          responsive: true,
                          plugins: {
                            legend: {
                              position: "bottom",
                              labels: {
                                color: "#334155",
                                font: { size: 10 },
                                boxWidth: 10,
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* ৩. 3-Month Performance Bar Chart */}
                <div className="col-12 col-lg-6">
                  <div
                    className="chart-container h-100"
                    style={{
                      background: "#fff",
                      padding: "20px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <h5
                      className="text-center mb-3"
                      style={{ color: "#1e293b", fontWeight: "600" }}
                    >
                      3-Month Business Overview
                    </h5>
                    <ChartBar data={barChartData} options={barChartOptions} />
                  </div>
                </div>
              </div>

              {/* ============================================================== */}
              {/* 🗂 কাউন্টার গ্রিড (ডেস্কটপে নিচে থাকবে: order-lg-2, মোবাইলে উপরে: order-1) */}
              {/* ============================================================== */}
              <div className="mt-0 mt-lg-5 orderCountlist order-1 order-lg-2 mb-5 mb-lg-0">
                {/* ======== Status Based Orders ======== */}
                <Link to="/orders/" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Total Orders</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.total_orders}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/new" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>New Orders</b>
                    </p>
                    <p
                      className="lengthCount text-warning"
                      style={{ fontWeight: "bold" }}
                    >
                      {dashboardData.new}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/pending" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Pending Orders</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.pending}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/return" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Returns</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.return_count}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/cancelled" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Cancelled</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.cancelled}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/confirmed" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Confirmed</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.confirmed}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/courier" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Courier</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.courier}
                    </p>
                  </div>
                </Link>

                <Link to="/orders/delivered" className="text-decoration-none">
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Delivered</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.delivered}
                    </p>
                  </div>
                </Link>

                <Link
                  to="/orders/money+collected"
                  className="text-decoration-none"
                >
                  <div className="dashboardData" style={{ background: "#fff" }}>
                    <p>
                      <b>Money Collected</b>
                    </p>
                    <p className="lengthCount" style={{ color: "#fff" }}>
                      {dashboardData.money_collected}
                    </p>
                  </div>
                </Link>

                {/* ======== Time Based Orders ======== */}
                <div className="dashboardData" style={{ background: "#fff" }}>
                  <p>
                    <b>Today Orders</b>
                  </p>
                  <p className="lengthCount" style={{ color: "#fff" }}>
                    {dashboardData.today_all}
                  </p>
                </div>

                <div className="dashboardData" style={{ background: "#fff" }}>
                  <p>
                    <b>Yesterday Orders</b>
                  </p>
                  <p className="lengthCount" style={{ color: "#fff" }}>
                    {dashboardData.yesterday_all}
                  </p>
                </div>

                {/* ======== অতিরিক্ত কার্ড ======== */}
                <div className="dashboardData" style={{ background: "#fff" }}>
                  <p>
                    <b>Today Confirmed</b>
                  </p>
                  <p className="lengthCount" style={{ color: "#fff" }}>
                    {dashboardData.today_confirm}
                  </p>
                </div>
              </div>
            </div>{" "}
            {/* ডেক্সটপ/মোবাইল রি-অর্ডার প্যারেন্ট শেষ */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

function StatusGridSkeleton() {
  const [cardCount, setCardCount] = useState(12); // ডিফল্ট ১২টা (মোবাইলের জন্য)

  useEffect(() => {
    // স্ক্রিন সাইজ চেক করার ফাংশন
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setCardCount(24); // পিসি/লার্জ স্ক্রিন হলে ২৮টা কার্ড
      } else {
        setCardCount(12); // মোবাইল বা ট্যাব হলে ১২টা কার্ড
      }
    };

    // কম্পোনেন্ট লোড হওয়ার সাথে সাথে একবার চেক করবে
    handleResize();

    // স্ক্রিন ছোট-বড় করলে ট্র্যাক রাখবে
    window.addEventListener("resize", handleResize);

    // মেমোরি লিক বন্ধ করতে ক্লিনআপ
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* স্কেলিটনের অ্যানিমেশন সিএসএস */}
      <style>{`
        @keyframes skeleton-glow {
          0% { opacity: 0.5; }
          50% { opacity: 1; }
          100% { opacity: 0.5; }
        }
        .skeleton-wrapper {
          animation: skeleton-glow 1.5s infinite ease-in-out;
        }
        
        .skeleton-card {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          padding: 18px 20px; 
          display: flex;
          align-items: center;
          justify-content: space-between; 
          box-shadow: 0 1px 3px rgba(0,0,0,0.02);
          height: 70px; 
        }

        .skeleton-text-bar {
          background: #e5e7eb;
          height: 16px;
          width: 55%;
          border-radius: 4px;
        }

        .skeleton-count-box {
          background: #059669;
          opacity: 0.15; 
          height: 36px;
          width: 55px;
          border-radius: 6px;
        }

        .loading-text {
          font-weight: 600;
          color: #6b7280;
          margin-bottom: 20px;
          letter-spacing: 1px;
          animation: skeleton-glow 1.5s infinite ease-in-out;
        }
      `}</style>

      {/* পারফেক্ট অল-রাউন্ড সেন্টারিং কন্টেইনার */}
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "85vh", width: "100%" }}
      >
        {/* লোডিং টেক্সট */}
        <div className="loading-text mt-5 pt-4">
          <span
            className="spinner-border spinner-border-sm me-2 text-success"
            role="status"
          />
          Dashboard Data Loading...
        </div>

        <div
          style={{ width: "75%" }}
          className="row justify-content-center align-items-center g-3 g-lg-4  py-2 px-2 px-md-4 text-center"
        >
          {/* এখানে ডায়নামিক cardCount বসানো হয়েছে */}
          {[...Array(cardCount)].map((_, index) => (
            <div
              key={index}
              className="col-12 col-md-4 col-lg-3 skeleton-wrapper"
            >
              <div className="skeleton-card">
                <div className="skeleton-text-bar" />
                <div className="skeleton-count-box" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
